import React from "react";
import {observer} from "mobx-react-lite";
import AdminMenu from "./AdminMenu";
import PageLayout from "../PageLayout";

const AdminHome = () => {
    return (
        <PageLayout header={
            <h4 className={"mb-0"}>Admin Home</h4>
        }>
            <div>This is Admin Home</div>
        </PageLayout>
    )
}
export default observer(AdminHome);